// extracted by mini-css-extract-plugin
export default {"card":"BY-z","carouselContainer":"CY-z","carouselContent":"DY-z"};